<template>
  <FilterBadge v-bind="{ ...$props, ...$attrs }" icon="fas fa-location-dot">
    {{ t("global.site") }}: {{ result?.Sites[0]?.name ?? filter.siteId }}
  </FilterBadge>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useTranslation } from "@/language/translation";
import { useSearchSiteQuery } from "@/graphql";
import SiteFilter from "../../filterImplementations/SiteFilter";
import FilterBadge from "./FilterBadge.vue";

const props = defineProps<{ filter: SiteFilter }>();
const { t } = useTranslation();
const { result } = useSearchSiteQuery(computed(() => ({ siteIds: [props.filter.siteId] })));
</script>
